import { Action } from "../../../actions/actions";
import { GamesActionTypes } from "../actions/actionTypes";

export enum CreationModes {
    ADD_GAME = "ADD_GAME",
    EDIT_GAME = "EDIT_GAME",
    ADD_CONFIGURATION = "ADD_CONFIGURATION",
    EDIT_CONFIGURATION = "EDIT_CONFIGURATION",
    ADD_BUNDLE = "ADD_BUNDLE",
    EDIT_BUNDLE = "EDIT_BUNDLE"
}

interface CreationModeState {
    mode: string | null;
}

export function creationMode(
    state: CreationModeState = { mode: null },
    action: Action
): CreationModeState {
    switch (action.type) {
        case GamesActionTypes.CREATION_MODE_CHANGE:
            return action.payload.mode;
        case GamesActionTypes.CREATE_GAME_RESET:
        case GamesActionTypes.CREATE_GAME_SUCCESS:
        case GamesActionTypes.EDIT_GAME_SUCCESS:
        case GamesActionTypes.CREATE_CONF_RESET:
        case GamesActionTypes.CREATE_CONF_SUCCESS:
        case GamesActionTypes.EDIT_CONF_SUCCESS:
        case GamesActionTypes.CREATE_BUNDLE_RESET:
        case GamesActionTypes.CREATE_BUNDLE_SUCCESS:
        case GamesActionTypes.EDIT_BUNDLE_SUCCESS:
            return { mode: null };
        default:
            return state;
    }
}
